export default "__VITE_ASSET__3kXurdo7__"